import React from "react";
import {CCol, CFormInput, CFormLabel, CFormText, CRow} from "@coreui/react";
import {useDispatch, useSelector} from "react-redux";
import {applyFilter} from "../../store/slice/component/table";

const CustomerSearch = () => {
    const dispatch = useDispatch([]);
    const data = useSelector(state => state.entities.component_table);
    return <>
        <CRow className={'mb-1'}>
            <CCol sm={12} md={6}>
                <CFormLabel>Customer Search</CFormLabel>
                <CFormInput type="text"
                            onChange={(e) => {
                                dispatch(applyFilter({
                                    field_name: 'customer_account_name',
                                    value: e.target.value,
                                }));
                            }}
                            defaultValue={data.customer_account_name || ''}
                />
                <CFormText>Example: Suresh Nai, Mahesh Mistry</CFormText>
            </CCol>
            <CCol sm={12} md={6}>
                <CFormLabel>By Customer Number</CFormLabel>
                <CFormInput type="text"
                            onChange={(e) => {
                                dispatch(applyFilter({
                                    field_name: 'customer_account_number',
                                    value: e.target.value,
                                }));
                            }}
                            defaultValue={data.customer_account_number || ''}
                />
                <CFormText>Example: UYUI7883, KIU39723</CFormText>
            </CCol>
        </CRow>
    </>;
}

export default CustomerSearch;
